import { Provider } from '../providers/provider';

const camelcaseKeysDeep = require('camelcase-keys-deep');

export class User {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  username: string;
  staff: boolean;
  active: boolean;
  key: string;
  lastLogin: string;
  joinedAt: string;
  loading: boolean;
  image: string;
  groups: string;
  permissions: string;
  status: boolean;
  provider: Provider;

  constructor(userInfo: any) {
    userInfo = camelcaseKeysDeep(userInfo);

    this.id = userInfo.id;
    this.email = userInfo.email;
    this.firstName = userInfo.firstName;
    if (!this.firstName || this.firstName && !this.firstName.length) {
      this.firstName = userInfo.provider && userInfo.provider.firstName;
    }
    this.lastName = userInfo.lastName;
    if (!this.lastName || this.lastName && !this.lastName.length) {
      this.lastName = userInfo.provider && userInfo.provider.lastName;
    }
    this.key = userInfo.key;
    this.staff = userInfo.isStaff;
    this.active = userInfo.isActive;
    this.joinedAt = userInfo.joinedAt;
    this.lastLogin = userInfo.lastLogin;
    this.image = userInfo.image;
    this.groups = userInfo.groups;
    this.permissions = userInfo.userPermissions;
    if (userInfo.provider) {
      userInfo.provider = userInfo.provider;
    }
    if (userInfo.provider && typeof (userInfo.provider) === 'object') {
      this.provider = new Provider(userInfo.provider);
    } else {
      this.provider = new Provider({id: userInfo.provider});
    }

    this.status = userInfo.provider && userInfo.provider.status;
  }

  get name(): string {
    if (this.firstName || this.lastName) {
      return this.firstName + ' ' + this.lastName;
    } else {
      return this.email;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/users/user.ts